export default "__VITE_ASSET__56776666__"